import { Component, OnInit } from '@angular/core';

import { Seguradora } from "../shared/seguradora.model";
import { SeguradoraApiService } from "../shared/seguradora-api.service";
import { SeguradoraService } from "../shared/seguradora.service";
import { SeguradoraNavigationService } from "../shared/seguradora-navigation.service";
import { seguradorasModuleName } from "../shared/data.service";
import { UtilService } from "../../../shared/services/util.service";
import { PessoaJuridicaApiService } from "../../../recursos-humanos/pessoa-juridica/shared/pessoa-juridica-api.service";
import { segurosModuleName } from "../../seguros/shared/data.service";

@Component({
    selector: 'app-seguradora-list',
    template: require('./seguradora-list.component.html'),
    styles: [require('./seguradora-list.component.css')]
})
export class SeguradoraListComponent implements OnInit {
    list: Seguradora[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    seguradorasModuleName: any = seguradorasModuleName;
    module: any = segurosModuleName;

    constructor(
        private _seguradorasApiService: SeguradoraApiService,
        private _seguradoraService: SeguradoraService,
        private _seguradoraNavigationService: SeguradoraNavigationService,
        private _pessoaJuridicaApiService: PessoaJuridicaApiService,
        private _utilService: UtilService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickNew() {
        this._seguradoraService.clearSessionStorage();
        this._seguradoraNavigationService.goToNew();
    }

    clickEdit(item: Seguradora) {
        this._seguradoraService.clearSessionStorage();
        this._seguradoraNavigationService.goToEdit(item.id);
    }

    clickDelete(item: Seguradora) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        var onDone = (function(Response) {
            if (!Response.error)  {
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._seguradorasApiService.onGetAll(onDone);
    }

    private onDelete(item) {
        var onDone = (function (Response) {
            if (!Response.error) {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();

                this.deletePessoaJuridica(item.pessoaJuridicaId);
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._seguradorasApiService.onDelete(item.id, onDone);
    }

    private deletePessoaJuridica(pessoJuridicaId:  number) {
        var onDone = (function (Response) {

        });

        this._pessoaJuridicaApiService.onDelete(pessoJuridicaId, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguradoras/seguradora-list/seguradora-list.component.ts
 **/